import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import WithAjax from '../../common/helpers/WithAjax'
import WithNotify from '../../common/helpers/WithNotify'
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import { clearClientRequestEditFields,
    setClientRequestEditLoadFields,
    validateClientRequestEditField,
    submitClientRequestEditFields
} from '../../../actions/pages/clientaccount-page'
import Alert from '../../../ui-elements/alerts/Alert'
import MultiSelect from '../../common/form/MultiSelect'
import InputField from '../../common/form/InputField'
import {validateField} from '../../../actions/helpers/validation'
import {fieldsToDataToSend} from '../../common/functions/convert'

class AcceptClientAccountPopup extends Component {
    constructor(props){
        super(props);
        this.state = {
            modal: false,
            errorMsg: null,
            account: []
          }

          this.toggle = this.toggle.bind(this);
          this.submitForm = this.submitForm.bind(this);
    }

    isEditMode(){
        return this.props.mode == "edit";
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });

        if (!this.state.modal) {
            this.props.clearClientRequestEditFields();

            let url = 'clientaccounts/' + this.props.accountId;
            this.props.ajax.get(url, true, (data) => {
                this.setState({account: data});
                data.AllCountries.Items.forEach((item) => {
                    item.value = item.value.toLowerCase();
                });
                data.Countries.forEach((country) => {
                    country = country.toLowerCase();
                });
                data.AllCountries.SelectedValue = data.Countries.join(',');
                this.props.setClientRequestEditLoadFields(data);
            });
        }
    }

    convertFieldsToSend(dataToSend){
        if (dataToSend.AllowedCountries){
            dataToSend.AllowedCountries = dataToSend.AllowedCountries.split(',');
        }

        return dataToSend;
    }

    submitForm(event){
        event.preventDefault();

        let validatedFields = this.props.fields.map(field => validateField(field));
        let isValid =
            validatedFields.filter(field => field.errors.length > 0).length > 0
            ? false
            : true;

        this.props.submitClientRequestEditFields(validatedFields);

        if (!isValid){
            return;
        }

        let dataToSend = this.convertFieldsToSend(fieldsToDataToSend(this.props.fields));

        let url = 'clientaccounts/' + this.props.accountId + (this.isEditMode() ? '' : '/activate');
        this.props.ajax.put(
            url,
            JSON.stringify(dataToSend),
            {
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
                }
            },
            (response) => {
                if (response.Status === 'OK') {
                    this.toggle();
                    this.props.notify("Client account has been " + (this.isEditMode() ? "updated." : "activated."));
                    this.props.onReload();
                }
                else{
                    this.setState({
                        errorMsg: "Can not " + (this.isEditMode() ? "update" : "activate") + " client account (id: ${this.props.accountId})"
                    })
                }
            }
        )
    }

    render() {
        let fields = this.props.fields;
        let buttonClass = "btn btn-rounded " + (this.isEditMode() ? "btn-primary" : "btn-success");

        return(
            <div style={{display: 'inline-block'}}>
                <Modal
                    isOpen={this.state.modal}
                    toggle={this.toggle}
                    wrapClassName='modal-primary'
                    size='lg'>
                    <ModalHeader toggle={this.toggle}>{this.isEditMode() ? 'Edit client account' : 'Activate client account'}</ModalHeader>
                    <ModalBody>
                        {this.state.errorMsg &&
                            <Alert className="alert alert-danger alert-outline">
                                {this.state.errorMsg}
                            </Alert>
                        }
                        <div className="row">
                            <div className="col-12 font-weight-bold">
                                <span>
                                    <img src={this.state.account.ProductionContentOwnerIconUrl} style={{width: '50px'}} alt="" />
                                </span>
                                <span style={{padding: '10px'}}>
                                    {this.state.account.ProductionContentOwnerName}
                                </span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">&nbsp;</div>
                        </div>
                        <div className="form-group">
                            <label className="col-form-label col-form-label-sm">Full name</label>
                            <div className="input-group">
                                <input type="text" disabled className="form-control form-control-sm" value={this.state.account.FullName || ''}></input>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-form-label col-form-label-sm">Job title</label>
                            <div className="input-group">
                                <input type="text" disabled className="form-control form-control-sm" value={this.state.account.JobTitle || ''}></input>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-form-label col-form-label-sm">Email</label>
                            <div className="input-group">
                                <input type="text" disabled className="form-control form-control-sm" value={this.state.account.Email || ''}></input>
                            </div>
                        </div>
                        <MultiSelect field={fields[0]} validate={this.props.validateClientRequestEditField}  />
                        <div className="row">
                            <div className="col-12">
                                <InputField field={fields[1]} validate={this.props.validateClientRequestEditField}  />
                            </div>
                        </div>
                        <div className="mb-5"></div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-primary btn-rounded" type="submit" onClick={this.submitForm}>
                            Activate
                        </button>
                        <button className="btn btn-default btn-rounded" onClick={this.toggle}>
                            Close
                        </button>
                    </ModalFooter>
                </Modal>
                <button
				    className={buttonClass}
				    type="button"
				    style={{marginRight:10}}
				    onClick={(e) => this.toggle()}>
				    {this.isEditMode() ? "Edit" : "Accept"}
			    </button>
            </div>
        );

    }
}

const mapStateToProps = (state) => ({
	fields: state.clientRequestActivate.fields
})
const mapDispatchToProps = dispatch => ({
	setClientRequestEditLoadFields(data) { dispatch(setClientRequestEditLoadFields(data)) },
	clearClientRequestEditFields() { dispatch(clearClientRequestEditFields()) },
	validateClientRequestEditField(value, field) { dispatch(validateClientRequestEditField(value, field)) },
	submitClientRequestEditFields(field) { dispatch(submitClientRequestEditFields(field)) },
})
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    WithAjax,
    WithNotify)(AcceptClientAccountPopup)
